var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5605 5.6899L10.3105 1.4394C10.0899 1.2188 9.8016 1.0763 9.496 1.0246V1H9.25H3.2095H2.5C1.6729 1 1 1.6729 1 2.5V13.5C1 14.3271 1.6729 15 2.5 15H3.6885H12.3936H13.5C14.3271 15 15 14.3271 15 13.5V6.7505C15 6.3501 14.8438 5.9731 14.5605 5.6899ZM8.4961 2V4.8647C8.4961 5.1406 8.2725 5.3647 7.9966 5.3647H4.7095C4.4336 5.3647 4.2095 5.1406 4.2095 4.8647V2H8.4961ZM4.6885 14V10.2734C4.6885 9.998 4.9126 9.7734 5.1885 9.7734H10.8936C11.169 9.7734 11.3936 9.998 11.3936 10.2734V14H4.6885ZM14 13.5C14 13.7754 13.7754 14 13.5 14H12.3936V10.2734C12.3936 9.4463 11.7207 8.7734 10.8936 8.7734H5.1885C4.3614 8.7734 3.6885 9.4463 3.6885 10.2734V14H2.5C2.2241 14 2 13.7754 2 13.5V2.5C2 2.2241 2.2241 2 2.5 2H3.2095V4.8647C3.2095 5.6918 3.8824 6.3647 4.7095 6.3647H7.9966C8.8233 6.3647 9.4961 5.6918 9.4961 4.8647V2.0747C9.5336 2.0964 9.5728 2.1155 9.6035 2.1464L13.8535 6.3969C13.9463 6.4902 14 6.6191 14 6.7505V13.5Z",
    fill: "#0072c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveStroke);
export default __webpack_public_path__ + "static/media/Save-Stroke.f6b3da8b6b8e98e14893057ad878a33d.svg";
export { ForwardRef as ReactComponent };